import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import settings from "../constants/settings";


export default function Copyright(props: any) {
    return (
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
        {'Copyright © '}
        <Link color="inherit" href={settings.copyRightURL}>
          {settings.websiteName}
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
  }